module.exports = __webpack_public_path__ + "static/media/display-logo-pegada-g.53496f89.png";